import { Link } from "react-router-dom";
import "./Institution.css";
import { FaArrowRight } from "react-icons/fa";
import Header from "../Header/Header";
import { GoCheckCircle } from "react-icons/go";
import { instCards, instWorkFlow } from "../utils/data";
import Footer from "../Footer/Footer";
import ReactFlagsSelect from "react-flags-select";
import useState from "react-usestateref";
import Select from "react-dropdown-select";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./Institution.css";
import { toast } from "react-hot-toast";
import { postMethod } from "../../core/service/common.api"; // adjust path
import apiService from "../../core/service/detail";
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";

countries.registerLocale(enLocale);

const Institution = () => {
  const [countrySelect, setCountrySelect] = useState("IN");
  const [CountryName, setCountryName, CountryNameref] = useState();
  const [categorySelect, setCategorySelect] = useState(null);
  const [formData, setFormData, formDataref] = useState({
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);

  const categoryOptions = [
    { value: "RealEstate", label: "Real Estate" },
    { value: "TreasuriesBonds", label: "Treasuries & Bonds" },
    { value: "PrivateCredit", label: "Private Credit" },
    { value: "Commodities", label: "Commodities" },
    { value: "Equities", label: "Equities" },
  ];
  const getCountryName = (code) => {
    console.log(countries.getName(code, "en"), "");
    setCountryName(countries.getName(code, "en"));
  };
  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formDataref.current, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
    validate();
  };

  // Validation
  const validate = () => {
    let tempErrors = {};

    // First Name
    if (!formDataref.current.firstName.trim()) {
      tempErrors.firstName = "First Name is required";
    } else if (formDataref.current.firstName.length < 2) {
      tempErrors.firstName = "First Name must be at least 2 characters";
    } else if (formDataref.current.firstName.length > 30) {
      tempErrors.firstName = "First Name cannot exceed 30 characters";
    }

    // Last Name (optional)
    if (
      formDataref.current.lastName &&
      (formDataref.current.lastName.length < 2 ||
        formDataref.current.lastName.length > 30)
    ) {
      tempErrors.lastName = "Last Name must be between 2 and 30 characters";
    }

    // Country
    if (!countrySelect) {
      tempErrors.country = "Country is required";
    }

    // Mobile number using react-phone-number-input
    // if (!formDataref.current.mobile) {
    //   tempErrors.mobile = "Mobile Number is required";
    // } else if (!isValidPhoneNumber(formDataref.current.mobile)) {
    //   tempErrors.mobile = "Invalid phone number for selected country";
    // }
    // Mobile number using react-phone-number-input
    if (!formDataref.current.mobile || !formDataref.current.mobile.trim()) {
      tempErrors.mobile = "Mobile Number is required";
    } else if (!isValidPhoneNumber(formDataref.current.mobile)) {
      tempErrors.mobile = "Invalid phone number for selected country";
    } else {
      const trimmed = formDataref.current.mobile.trim();
      const countryCode = trimmed.match(/^\+\d+/)?.[0] || ""; // Extract country code
      const actualMobileLength = trimmed.replace(countryCode, "").length;

      // if (actualMobileLength < 7) {
      //   tempErrors.mobile = "Invalid number, must be at least 7 digits excluding country code";
      // }
    }

    // Email
    if (!formDataref.current.email.trim()) {
      tempErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formDataref.current.email)) {
      tempErrors.email = "Invalid email format";
    }

    // Category
    if (!categorySelect) {
      tempErrors.category = "Category is required";
    }

    // Message
    if (!formDataref.current.message.trim()) {
      tempErrors.message = "Message is required";
    } else if (formDataref.current.message.length < 10) {
      tempErrors.message = "Message must be at least 10 characters";
    } else if (formDataref.current.message.length > 500) {
      tempErrors.message = "Message cannot exceed 500 characters";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoader(true);

    // Example API call
    const payload = {
      firstName: formDataref.current.firstName,
      lastName: formDataref.current.lastName,
      country: CountryNameref.current,
      mobile: formDataref.current.mobile,
      email: formDataref.current.email,
      category: categorySelect.value,
      message: formDataref.current.message,
    };

    const data = {
      apiUrl: apiService.createIssuer, // replace with your actual API endpoint
      payload: payload,
    };

    const resp = await postMethod(data);
    setLoader(false);

    if (resp?.status === true) {
      toast.success(resp?.message);
      setFormData({
        firstName: "",
        lastName: "",
        mobile: "",
        email: "",
        message: "",
      });
    } else {
      toast.error(resp?.message);
    }

    console.log("Payload to API:", payload);
  };

  return (
    <>
      <Header />
      <main className="inst_main">
        <section className="inst_hero">
          <div className="container-md">
            <div className="new-class">
              <h1 className="inst_title">
                Turning Real World Assets into Valuable Digital Tokens
              </h1>
              <p className="inst_cnt">
                Empowering businesses, governments, and developers to compliantly
                tokenize real-world assets through secure, institutional-grade
                infrastructure.
              </p>
              <div className="inst_hero_btn_wrap">
                <a href="#contact" className="inst_hero_btn_rgt">
                  <span>
                    Get Started <FaArrowRight />
                  </span>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* work */}
        <section className="inst_work">
          <div className="container-md">
            <h3 className="inst_subtitle text-center">
              Institutions who work <span>with us</span>{" "}
            </h3>
            <p className="inst_subcontent inst_wrk_cnt">
              Our mission is to transform real-world assets into liquid, digital
              opportunities accessible to anyone, anywhere. By bridging
              traditional finance with blockchain, we unlock secure,
              transparent, and borderless ownership for the next generation of
              investors.
            </p>
            <div className="inst_wk_outer">
              <div className="wk_img_wrap_top">
                <div className="wk_img_wrap wk_img_pr">
                  <img
                    src={
                      new URL("../../assets/wk_img_one.webp", import.meta.url)
                    }
                    alt=""
                    className="wk_img"
                  />
                </div>
                <div className="wk_img_wrap wk_img_pr">
                  <img
                    src={
                      new URL("../../assets/wk_img_two.webp", import.meta.url)
                    }
                    alt=""
                    className="wk_img"
                  />
                </div>
                <div className="wk_img_wrap">
                  <img
                    src={
                      new URL("../../assets/wk_img_three.webp", import.meta.url)
                    }
                    alt=""
                    className="wk_img"
                  />
                </div>
              </div>
              <div className="wk_img_wrap_top justify-content-center">
                <div className="wk_img_wrap wk_img_pr">
                  <img
                    src={
                      new URL("../../assets/wk_img_four.webp", import.meta.url)
                    }
                    alt=""
                    className="wk_img_two"
                  />
                </div>
                <div className="wk_img_wrap">
                  <img
                    src={
                      new URL("../../assets/wk_img_five.webp", import.meta.url)
                    }
                    alt=""
                    className="wk_img_two"
                  />
                </div>
              </div>
            </div>
            <div className="inst_wk_btn_wrap">
              <a href={"#contact"} className="inst_wk_btn">
                <span>
                  Join With Us <FaArrowRight />
                </span>
              </a>
            </div>
          </div>
        </section>

        {/* choose */}
        <section className="inst_choose">
          <div className="container-md">
            <h3 className="inst_subtitle text-center">
              Why do institutions choose <span>Assetly</span>
            </h3>
            <p className="inst_subcontent inst_wrk_cnt">
              Assetly bridges traditional finance with blockchain by
              transforming real-world assets into secure digital tokens. This
              creates transparency, liquidity, and accessibility—unlocking
              opportunities for institutions and everyday investors alike.
            </p>

            <div className="row g-4 mt-2 justify-content-center why_chs_inst_wrp">
              {instCards.map((card) => (
                <div key={card.id} className="col-xxl-3 col-lg-4 col-sm-6">
                  <div className="inst_ch_card_outer">
                    <div className="inst_ch_card">
                      <div className="inst_ch_top">
                        <img src={card.img} alt={card.title} />
                        <h5 className={card.id === 6 ? "ch_sx_title" : ""}>
                          {card.title}
                        </h5>
                      </div>
                      <p>{card.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* trust */}
        <div className="container-md">
          <section className="inst_trust">
            <div className="row g-4">
              <div className="col-lg-6">
                <h6 className="inst_trust_title">
                  Why Institutions <span>Trust</span> Assetly
                </h6>
                <div className="d-flex mt-4">
                  <Link to={"/contact"} className="inst_wk_btn">
                    <span>
                      Contact Us <FaArrowRight />
                    </span>
                  </Link>
                </div>
              </div>
              <div className="col-lg-6 inst_why_list_col">
                <div className="row g-3 inst_why_list_wrp">
                  <div className="col-sm-6">
                    <div className="inst_tst_flx_wrap">
                      <p className="inst_tst_flx">
                        {" "}
                        <GoCheckCircle />
                        <span>Tokenization at Scale</span>
                      </p>
                      <p className="inst_tst_flx">
                        {" "}
                        <GoCheckCircle />
                        <span>Secure Custody Solutions</span>
                      </p>

                      <p className="inst_tst_flx">
                        {" "}
                        <GoCheckCircle />
                        <span>Data Transparency</span>
                      </p>
                      <p className="inst_tst_flx">
                        {" "}
                        <GoCheckCircle />
                        <span>Regulatory Confidence</span>
                      </p>
                      <p className="inst_tst_flx">
                        {" "}
                        <GoCheckCircle />
                        <span>Compliance & KYC verification</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="inst_tst_flx_wrap">
                      <p className="inst_tst_flx">
                        {" "}
                        <GoCheckCircle />
                        <span>New Revenue Streams</span>
                      </p>
                      <p className="inst_tst_flx">
                        {" "}
                        <GoCheckCircle />
                        <span>Global Market Access</span>
                      </p>
                      <p className="inst_tst_flx">
                        {" "}
                        <GoCheckCircle />
                        <span>Institutional Support</span>
                      </p>
                      <p className="inst_tst_flx">
                        {" "}
                        <GoCheckCircle />
                        <span>Operational Efficiency</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* work for institution */}
        <div className="container-md">
          <section className="inst_wk_institution">
            <h3 className="inst_subtitle text-center">
              How Assetly Works for <span>Institutions</span>
            </h3>
            <p className="inst_subcontent inst_wk_cnt">
              Our platform combines secure tokenization, built-in compliance,
              and global investor access. With enterprise-grade infrastructure,
              institutions can scale confidently in the digital economy.
            </p>

            {instWorkFlow.map((step) => (
              <div key={step.id} className="row g-3 g-md-4 inst_wk_fr_row">
                {/* Step number */}
                <div className="col-md-2">
                  <span className="inst_num">{step.id}</span>
                </div>

                {/* Step image */}
                <div className="col-md-2 d-none d-md-block">
                  <div className="inst_wk_img_outer">
                    <div className="inst_wk_img_inner">
                      <img src={step.img} alt={step.title} />
                    </div>
                  </div>
                </div>

                {/* Title */}
                <div className="col-md-4">
                  <h5 className="inst_wk_fr_title">{step.title}</h5>
                </div>

                {/* Description */}
                <div className="col-md-4">
                  <p className="inst_wk_fr_cnt">{step.desc}</p>
                </div>
              </div>
            ))}
          </section>
        </div>
        <div id="contact" className="container-md inst_wrk_container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-6 col-xxl-7 inst_wrk_col1">
              <div className="inst_formContnt">
                <h3 className="inst_subtitle inst_st_title">
                  Start tokenizing your real world assets
                </h3>
                <div className="inst_wrk_line"></div>
                <p className="inst_wrk_desc">
                  “Assetly is a next-generation platform that empowers
                  institutions to tokenize, manage, and trade real-world assets
                  seamlessly. With a focus on transparency, compliance, and
                  efficiency, Assetly bridges traditional finance with
                  blockchain innovation to unlock new opportunities. Feel free
                  to contact us for further details or collaboration.”
                </p>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-6 col-xxl-5">
              <div className="inst_form_card">
                <div className="form_notes">
                  <p>Please fill in all required fields</p>
                </div>
                <form className="inst_form" onSubmit={handleSubmit}>
                  <div className="form_group">
                    <input
                      type="text"
                      name="firstName"
                      className="form_input"
                      value={formDataref.current.firstName}
                      onChange={handleChange}
                      placeholder="First Name*"
                    />
                    {errors.firstName && (
                      <span className="error mt-2 d-block">
                        {errors.firstName}
                      </span>
                    )}
                  </div>

                  <div className="form_group">
                    <input
                      type="text"
                      name="lastName"
                      className="form_input"
                      value={formDataref.current.lastName}
                      onChange={handleChange}
                      placeholder="Last Name"
                    />
                    {errors.lastName && (
                      <span className="error mt-2 d-block">
                        {errors.lastName}
                      </span>
                    )}
                  </div>

                  <div className="form_group form_country">
                    <ReactFlagsSelect
                      selected={countrySelect}
                      onSelect={(code) => {
                        setCountrySelect(code),
                          console.log(countrySelect),
                          getCountryName(code);
                      }}
                      className="form_input"
                      searchable
                    />
                    {errors.country && (
                      <span className="error mt-2 d-block">
                        {errors.country}
                      </span>
                    )}
                  </div>

                  <div className="form_group">
                    <PhoneInput
                      limitMaxLength={15}
                      defaultCountry={countrySelect}
                      selected={countrySelect}
                      value={formDataref.current.mobile}
                      onChange={(value) =>
                        setFormData({ ...formDataref.current, mobile: value })
                      }
                      international
                      countryCallingCodeEditable={false}
                      placeholder="Enter phone number"
                    />
                    {errors.mobile && (
                      <span className="error mt-2 d-block">
                        {errors.mobile}
                      </span>
                    )}
                  </div>

                  <div className="form_group">
                    <input
                      type="text"
                      name="email"
                      className="form_input"
                      value={formDataref.current.email}
                      onChange={handleChange}
                      placeholder="Email*"
                    />
                    {errors.email && (
                      <span className="error mt-2 d-block">{errors.email}</span>
                    )}
                  </div>

                  <div className="form_group">
                    <label htmlFor="">Category</label>
                    <Select
                      options={categoryOptions}
                      value={categorySelect}
                      onChange={(values) => setCategorySelect(values)}
                      className="form_input form_select"
                      placeholder="Category"
                    />
                    {errors.category && (
                      <span className="error mt-2 d-block">
                        {errors.category}
                      </span>
                    )}
                  </div>

                  <div className="form_group">
                    <textarea
                      name="message"
                      className="form_textarea"
                      value={formDataref.current.message}
                      onChange={handleChange}
                      placeholder="Message"
                    ></textarea>
                    {errors.message && (
                      <span className="error">{errors.message}</span>
                    )}
                  </div>

                  <button className="form_submit" disabled={loader}>
                    {loader ? "Sending..." : "Send Message"}
                  </button>
                </form>

                <p className="form_description">
                  By clicking, you agree to receive communications from Assetly
                  in accordance with our <Link>Privacy Policy.</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <div className="inst_footer_wrap">
        <Footer />
      </div>
    </>
  );
};

export default Institution;
